import * as React from 'react';
import { PrescriptionTable } from './PrescriptionTable.js';

const PrescriptionTableContainer = ({ orientation , prescription , name , size , formatPrescription =false ,  })=>{
    return /*#__PURE__*/ React.createElement(PrescriptionTable, {
        orientation: orientation,
        prescription: prescription,
        "aria-label": name,
        size: size,
        formatLabels: formatPrescription
    });
};

export { PrescriptionTableContainer, PrescriptionTableContainer as default };
//# sourceMappingURL=PrescriptionTableContainer.js.map
